import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0069',
    ecrans: ['00-2'],
    params: ['?ofacleint', '?caecleint', '?eplcleint', '?eplnummat', '?ofadatdeb', '?ofadatfin']
});
